
import React from "react";
import { FiPhone, FiMail, FiGlobe } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import "./DigitalCard.css";
import { hasLogged, markLogged } from "../utils/analyticsGuard";
import { RiTokenSwapFill } from "react-icons/ri";

export default function DigitalCard({ user, token }) {

  const formatWhatsAppNumber = (phone) => {
    return phone.replace(/\D/g, "");
  }

  const formatTelNumber = (phone) => {
    return phone.replace(/\s+/g, "");
  };

  const handleAddToContact = async (e) => {
    e.preventDefault();

    try {
      console.log('Handle Add to Contact');
      console.log('token: ' + token);

      const key = `add_contact_${token}`;
      if (hasLogged(key)) return;

      await fetch("https://bcard-api.visionwaretechnologies.com/api/qr/event", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userGuid: token,
          eventType: "ADD_TO_CONTACT"
        })
      })
        .then(() => markLogged(key));

    } catch (err) {
      // Ignore analytics errors
    } finally {
      // Always allow vCard download
      window.location.href = user.vcard;
    }
  };


  return (
    <div className="card">
      <div className="header">
        <img
          src={user.logo || "/visionware.png"}
          alt="Company Logo"
          className="logo"
          onError={(e) => (e.currentTarget.src = "/visionware.png")}
        />

        <img
          src={user.photo || "/avatar.png"}
          alt="Profile"
          className="avatar"
          onError={(e) => (e.currentTarget.src = "/avatar.png")}
        />
      </div>

      <div className="content">
        <h2>{user.name}</h2>
        <p className="title">{user.title}</p>
        <p className="company">{user.company}</p>

        <p className="desc">
          {user.desc}
        </p>

        <div className="contact">

          <div className="contact-row">
            <div className="contact-left">
              <FiPhone className="contact-icon" />
              <span>{user.phone}</span>
            </div>

            <div className="contact-actions">
              <a href={`tel:${formatTelNumber(user.phone)}`} aria-label="Call">
                <FiPhone />
              </a>
              <a
                href={`https://wa.me/${formatWhatsAppNumber(user.phone)}`}
                target="_blank"
                rel="noreferrer"
                aria-label="WhatsApp"
                className="whatsapp"
              >
                <FaWhatsapp />
              </a>
            </div>
          </div>

          <div className="contact-row">
            <div className="contact-left">
              <FiMail className="contact-icon" />
              <span>{user.email}</span>
            </div>

            <div className="contact-actions">
              <a href={`mailto:${user.email}`} >
                <FiMail />
              </a>
            </div>
          </div>

          <div className="contact-row">
            <div className="contact-left">
              <FiGlobe className="contact-icon" />
              <span>{user.website}</span>
            </div>

            <div className="contact-actions">
              <a
                href={`https://${user.website}`}
                target="_blank"
                rel="noreferrer"
              >
                <FiGlobe />
              </a>
            </div>
          </div>
        </div>

      </div>

      <a
        className="add"
        onClick={handleAddToContact}
      >
        + Add to Contacts
      </a>


      {/* <a href={user.vcard}
        className="add"
        onClick={handleAddToContact}
      // onClick={() => {
      //   const key = `add_contact_${token}`;
      //   if (hasLogged(key)) return;

      //   const payload = JSON.stringify({
      //     userGuid: token,
      //     eventType: "ADD_TO_CONTACT"
      //   });

      //   if (navigator.sendBeacon) {
      //     const success = navigator.sendBeacon(
      //       "https://bcard-api.visionwaretechnologies.com/api/qr/event",
      //       new Blob([payload], { type: "application/json" })
      //     );
      //     console.log('Beacon status: ', success);
      //     if (success) return;
      //   }

      //   fetch("https://bcard-api.visionwaretechnologies.com/api/qr/event", {
      //     method: "POST",
      //     headers: { "Content-Type": "application/json" },
      //     body: payload,
      //     keepalive: true
      //   });

      // }}
      >
        + Add to Contacts
      </a> */}

      {/* <div className="content">
        <h2>Senthilkumar Kalimuthu</h2>
        <p className="title">Technical Sales Consultant</p>
        <p className="company">Visionware Technologies</p>

        <p className="desc">
          Machine Vision Systems, AI Machine Vision Software, Customized Vision Solutions.
        </p>

        <div className="contact">

          <div className="contact-row">
            <div className="contact-left">
              <FiPhone className="contact-icon" />
              <span>+91 7204150612</span>
            </div>

            <div className="contact-actions">
              <a href="tel:+917204150612" aria-label="Call">
                <FiPhone />
              </a>
              <a
                href="https://wa.me/917204150612"
                target="_blank"
                rel="noreferrer"
                aria-label="WhatsApp"
                className="whatsapp"
              >
                <FaWhatsapp />
              </a>
            </div>
          </div>


          <div className="contact-row">
            <div className="contact-left">
              <FiMail className="contact-icon" />
              <span>sales.in@visionwaretechnologies.com</span>
            </div>

            <div className="contact-actions">
              <a href="mailto:sales.in@visionwaretechnologies.com">
                <FiMail />
              </a>
            </div>
          </div>

          <div className="contact-row">
            <div className="contact-left">
              <FiGlobe className="contact-icon" />
              <span>visionwaretechnologies.com</span>
            </div>

            <div className="contact-actions">
              <a
                href="https://visionwaretechnologies.com"
                target="_blank"
                rel="noreferrer"
              >
                <FiGlobe />
              </a>
            </div>
          </div>
        </div>

      </div>

      <a href="/senthilkumar-kalimuthu.vcf" className="add">
        + Add to Contacts
      </a> */}
    </div>
  );
}
